<template>
    <div>
      <base-button @click="showModal">All Contacts</base-button>
      <InfoModal
      :is-modal-visible="isModalVisible"
          @close="closeModal"
      >
        <template #header>
          Contacts
        </template>
        <template #body>
            <AllContactsList :company="company" @refetch-companies="fetchNewCompanies" />
        </template>
      </InfoModal>
    </div>
  
  </template>
  
  <script>
      export default {
          name: 'all-contacts-cell'
      }
  </script>
  
  <script setup>
    import {ref, defineProps, defineEmits} from "vue";
    import InfoModal from "../InfoModal.vue"
    import AllContactsList from "./AllContactsList.vue";
  
    const isEditable = ref(false)
    const isModalVisible = ref(false)
  
    const props = defineProps({
        company: Object
    })
  
    const emit = defineEmits(['refetch-companies'])
  
    function fetchNewCompanies () {
        emit('refetch-companies')
    }
  
    function showModal () {
      isModalVisible.value = true
    }
  
    function closeModal () {
      isEditable.value = false
      isModalVisible.value = false
    }
  </script>